import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'

import { EncryptedWallet } from './EncryptedWallet'

const VaultPropsSchema = z.object({
  version: z.literal('2'),
  encryptedWallet: z.instanceof(EncryptedWallet),
  encryptedV1Backup: z.instanceof(EncryptedWallet).optional(),
})

type VaultProps = z.infer<typeof VaultPropsSchema>

/**
 * The Vault is the encrypted storage for the wallet. It is responsible for storing the encrypted wallet and
 * encrypted v1 backup.
 */
export class Vault extends ValueObject<VaultProps> {
  public getVersion(): VaultProps['version'] {
    return this.props.version
  }

  public getEncryptedWallet(): EncryptedWallet {
    return this.props.encryptedWallet
  }

  public getV1BackupValue(): EncryptedWallet | undefined {
    return this.props.encryptedV1Backup
  }

  public static create(props: VaultProps): Vault {
    const validatedProps = VaultPropsSchema.parse(props)
    return new Vault(validatedProps)
  }
}
